var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExploreOutlineGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.77 6.647a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z",
    fill: "#1253fa",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.289.686a5.971 5.971 0 014.536 2.122 6.196 6.196 0 011.45 4.465 6.161 6.161 0 01-2.753 4.718c.238.154.466.326.682.514a6.193 6.193 0 012.11 4.689 6.183 6.183 0 01-1.707 4.263 5.951 5.951 0 01-4.113 1.854l-11.525.003c.684-.564 1.153-.803 1.483-1.228.24-.31.416-.711.416-1.233-.136-.691-.184-.882-.188-1.072 1.243-.994 1.677-1.563 1.677-2.335a2.356 2.356 0 00-.237-.992c.68-1.428.953-2.019.98-2.647a2.182 2.182 0 00-.488-1.36c-.205-.195-.29-.36-.314-.537.623-.885.779-1.354.793-1.839a2.091 2.091 0 00-.795-1.636c-.162-.111-.41-.233-.418-.48.372-.83.443-1.166.444-1.501a2.062 2.062 0 00-.311-1.112 2.029 2.029 0 00-.863-.766C4.86 2.89 4.731 2.368 4.51 1.978a1.901 1.901 0 00-.747-.746L3.7 1.201z",
    stroke: "#1253fa",
    strokeWidth: 1.372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.27 2.744a3.85 3.85 0 012.755 1.163 4.012 4.012 0 011.147 2.82 4.011 4.011 0 01-1.146 2.82 3.85 3.85 0 01-2.752 1.163 3.853 3.853 0 01-2.754-1.163 4.015 4.015 0 01-1.148-2.82 4.005 4.005 0 011.144-2.82 3.848 3.848 0 012.754-1.163z",
    stroke: "#1253fa",
    strokeWidth: 1.4
  }))));
}
export default SvgExploreOutlineGradient;